import { tableActionsCreator } from "app/actions/tableActions";
import { showSuccessToast } from "app/actions/toast_actions";
import { swSettings } from "app/common/services/swSettings";
import { SWReactTableWrapperWithSelection } from "app/components/React/Table/SWReactTableWrapperWithSelection";
import { DomainSelection } from "app/components/React/TableSelectionComponents/DomainSelection";
import { getToastItemComponent } from "app/components/React/Toast/ToastItem";
import { KeywordCompetitorsTableTop } from "app/pages/keyword-research/website-analysis/pages/search-competitors/KeywordCompetitorsTableTop";
import queryString from "query-string";
import type { FunctionComponent } from "react";
import { useState } from "react";
import { connect } from "react-redux";
import DurationService from "app/services/DurationService";
import { allTrackers } from "app/services/track/track";
import { getColumns } from "app/pages/keyword-research/website-analysis/pages/search-competitors/KeywordCompetitorsPageColumns";
import { MAX_DOMAINS_IN_CATEGORY } from "app/components/customCategoriesWizard/custom-categories-max-domains";
import { useCurrentStateAndParams } from "@uirouter/react";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { chosenSites } from "app/common/services/chosenSites";
import { QualificationSideBarHOC } from "app/components/QualificationSideBar/QualificationSideBarHOC";
import { entities } from "app/common/keyword-research/serp-players/consts";
import { getTableSelectedItems } from "app/reducers/_reducers/tableSelection.reducer";
const KeywordCompetitors: FunctionComponent<any> = (props) => {
    const { params, state } = useCurrentStateAndParams();
    const enableQualificationSideBar = !!state.qualificationSideBarComponent;
    const downloadExcelPermitted = swSettings.current.resources.IsExcelAllowed;
    const [tableData, setTableData] = useState();
    const [allCategories, setAllCategories] = useState([]);
    const [mainSiteData, setMainSiteData] = useState<any>();
    const chosenItems = chosenSites.map((item, infoItem) => {
        return { name: item, displayName: infoItem.displayName, icon: infoItem.icon };
    });
    const CATEGORY_ALL = "All";

    const {
        key,
        country,
        isWWW,
        duration,
        selectedSite,
        risingCompetitors,
        newCompetitors,
        category,
        webSource,
        search,
        websiteType,
        orderby = "Affinity desc",
        selectedPageTab,
    } = params;
    const {
        selectedRows,
        clearAllSelectedRows,
        showToast,
        tabMetaData,
        keywordTargetState = "organicsearch_websites_v2_traffic_keywords",
    } = props;
    const isCompare = chosenSites.isCompare();

    const { from, to } = DurationService.getDurationData(duration).forAPI;

    const getInitialParams = () => {
        const sort = orderby.split(" ")[0];
        const asc = orderby.split(" ")[1] === "asc";

        return {
            country,
            keys: selectedSite ?? key.split(",")[0],
            includeSubdomains: isWWW === "*",
            category: category !== CATEGORY_ALL ? category : undefined, //fix default category param All
            to,
            from,
            sort,
            asc,
            search,
            websiteType,
            risingCompetitors: risingCompetitors === "true",
            newCompetitors: newCompetitors === "true",
            webSource,
            searchType: params[tabMetaData.searchTypeParam],
            page: 0,
            pageSize: 400,
            selectedPageTab,
        };
    };

    const getDataCallback = (data) => {
        const { CategoriesCount: Categories, TotalTraffic, Traffic } = data.Header;
        setAllCategories(Categories);
        setTableData(data.Data);
        setMainSiteData({
            TotalTraffic,
            Traffic,
        });
    };
    const transformData = (data) => {
        return {
            ...data,
            Records: data.Data.map((record) => {
                return {
                    ...record,
                    url: proNavigator.href(keywordTargetState, {
                        ...proNavigator.getParams(),
                        key: record.Domain,
                        selectedPageTab,
                    }),
                    Affinity: record.Affinity,
                    KeywordOverlap: record.KwCount,
                    TotalKeywords: record.KwTotal,
                    OrganicTraffic: record.OrganicTraffic,
                    TotalTraffic: record.TotalTraffic,
                };
            }),
        };
    };
    const onSort = ({ field, sortDirection }) => {
        proNavigator.applyUpdateParams({
            orderby: `${field} ${sortDirection}`,
        });
    };
    const getExcelUrl = () => {
        const adaptedParams = dataParamsAdapter(getInitialParams());
        const queryStringParams = queryString.stringify(adaptedParams);
        return `${tabMetaData.excelApi}?${queryStringParams}`;
    };

    const dataParamsAdapter = (params) => {
        const transformedParams = { ...params };
        const filter = [];
        // category
        if (transformedParams.category) {
            filter.push(`category;contains;"${transformedParams.category.replace("~", "/")}"`);
            delete transformedParams.category;
        }
        // search
        if (transformedParams.search) {
            filter.push(`domain;contains;"${transformedParams.search}"`);
            delete transformedParams.search;
        }

        // website type
        if (transformedParams.websiteType) {
            filter.push(`SiteFunctionality;==;"${transformedParams.websiteType}"`);
            delete transformedParams.websiteType;
        }

        // search type
        if (transformedParams.searchType) {
            filter.push(`${transformedParams.searchType};==;true`);
            delete transformedParams.searchType;
        }

        // new
        if (transformedParams.newCompetitors) {
            filter.push(`isnew;==;${transformedParams.newCompetitors}`);
        }
        delete transformedParams.newCompetitors;

        // rising
        if (transformedParams.risingCompetitors) {
            filter.push(`isrise;==;${transformedParams.risingCompetitors}`);
        }
        delete transformedParams.risingCompetitors;

        if (filter.length > 0) {
            transformedParams.filter = filter.join(",");
        }
        // selected domain
        if (transformedParams.selectedSite) {
            transformedParams.keys = transformedParams.selectedSite;
            delete transformedParams.selectedSite;
        }

        // orderby
        transformedParams.orderby = `${transformedParams.sort} ${transformedParams.asc ? "asc" : "desc"}`;

        if (typeof transformedParams.page == "number") {
            transformedParams.page += 1;
        }
        delete transformedParams.sort;
        delete transformedParams.asc;
        delete transformedParams.orderBy;

        return transformedParams;
    };
    return (
        <SWReactTableWrapperWithSelection
            shouldSelectRow={(row) => row.Domain !== "grid.upgrade"}
            tableSelectionKey={tabMetaData.metric}
            tableSelectionProperty="Domain"
            maxSelectedRows={MAX_DOMAINS_IN_CATEGORY}
            cleanOnUnMount={true}
            fetchServerPages={4}
            rowsPerPage={100}
            selectAllCount={100}
            tableOptions={{
                aboveHeaderComponents: [
                    <DomainSelection
                        key="DomainSelection"
                        appendTo={`.${tabMetaData.metric} .swReactTable-header-wrapper`}
                        showToast={showToast}
                        clearAllSelectedRows={clearAllSelectedRows}
                        selectedRows={selectedRows}
                        createGroupButtonKey={"table.selection.create.group.button"}
                        addToGroupButtonKey={"table.selection.custom.industry.group"}
                        searchListsPlaceholderKey={"table.selection.search.industries.placeholder"}
                        entity={entities.domain}
                    />,
                ],
                metric: tabMetaData.metric,
                tableSelectionTrackingParam: "Domain",
                trackName: tabMetaData.tableSelectionTracking,
                customTableClass: tabMetaData.metric,
            }}
            serverApi={tabMetaData.tableApi}
            tableColumns={getColumns({
                tabMetaData,
                orderBy: orderby,
                onSelectCategory: (cat) => {
                    allTrackers.trackEvent("Internal Link", "click", `Category/${cat}`);
                    proNavigator.applyUpdateParams({ category: cat.replace("/", "~") }, { reload: true });
                },
                isPaid: tabMetaData.isPaid === true,
                handleOpenQualificationSideBar: enableQualificationSideBar && props.handleOpenQualificationSideBar,
                params,
                keywordTargetState,
            })}
            initialFilters={getInitialParams()}
            recordsField="Records"
            totalRecordsField="TotalCount"
            onSort={onSort}
            getDataCallback={getDataCallback}
            transformData={transformData}
            dataParamsAdapter={dataParamsAdapter}
        >
            {(topComponentProps) => (
                <KeywordCompetitorsTableTop
                    {...topComponentProps}
                    isCompare={isCompare}
                    allCategories={allCategories}
                    selectedSites={chosenItems}
                    selectedSite={selectedSite}
                    downloadExcelPermitted={downloadExcelPermitted}
                    excelLink={getExcelUrl()}
                    tableData={tableData}
                    searchTypeParam={tabMetaData.searchTypeParam}
                    searchTypes={tabMetaData.searchTypes}
                    searchTypeFilterPlaceholder={tabMetaData.searchTypeFilterPlaceholder}
                    title={tabMetaData.title}
                    mainSiteData={mainSiteData}
                    domainsCountApi={tabMetaData.domainsCountApi}
                />
            )}
        </SWReactTableWrapperWithSelection>
    );
};

const mapStateToProps = (state, { tabMetaData: { tableSelectionKey } }) => {
    return {
        selectedRows: getTableSelectedItems(tableSelectionKey)(state),
    };
};
const mapDispatchToProps = (dispatch, { tabMetaData }) => {
    return {
        clearAllSelectedRows: () => {
            dispatch(tableActionsCreator(tabMetaData.metric, "Domain").clearAllSelectedRows());
        },
        showToast: (href, text, label) => {
            dispatch(
                showSuccessToast(
                    getToastItemComponent({
                        text,
                        linkText: label,
                        href,
                        onClick: () =>
                            allTrackers.trackEvent(
                                "add to Custom Category",
                                "click",
                                "internal link/websites.overview",
                            ),
                    }),
                ),
            );
        },
    };
};

export const Connected = connect(mapStateToProps, mapDispatchToProps)(QualificationSideBarHOC(KeywordCompetitors));
